// 此逻辑移除了点击按钮的表单校验逻辑，适用于一个页面多处验证码校验场景
<template>
  <div>
    <div ref="captchaButtonRef" id="captcha-button">
      <!-- 插槽文字 -->
      <slot></slot>
    </div>
    <div id="captcha-element"></div>
  </div>
</template>
<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { BUSITYPE } from "../../assets/js/utils/others";
export default {
  data () {
    // 这里存放数据
    return {
      captcha: null,
      captchaButton: null,
    }
  },
  props: {
    handCallback: Function,
    targetId: String,
    mobile: String,
    verifyType: Number,
    parameters: { type: Object, default: () => { } },
    stateless:{type:Boolean,default:false}
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /**
     * @verifyType 业务场景
     */
    /**
     * 验证码验证回调函数
     * @param {Object} captchaVerifyParam - 验证码验证参数
     * @returns {Promise<Object>} - 返回一个Promise对象，包含验证码验证结果和业务验证结果
     *
     * 该函数用于处理验证码验证后的回调逻辑，根据不同的业务类型向后端发起请求，
     * 获取验证码验证结果和业务验证结果，并构造标准的返回参数。
     *
     * 注意：该函数内部使用了异步操作，需通过await关键字等待结果。
     */
    async captchaVerifyCallback (captchaVerifyParam) {
      return new Promise(async (resolve, reject) => {
        // 1.向后端发起业务请求，获取验证码验证结果和业务结果
        const param = {
          captchaVerifyParam,// 验证码参数
          source: 1, // 1 web  2 h5
          targetId: '', // 手机号或者邮箱
          // origin 参照account.ebaoquan.org/login/sendLoginCode 的origin 有则照着给没有就不管他
        }
        const { targetId, mobile, verifyType, parameters } = this,
          { LOGINBUSI,
            REGISTERBUSI,
            FORGETBUSI,
            AUTHBUSI,
            ADDSBUSI,
            AuthSendVerifiy,
            SIGNBUSI,
            RETRIEVEACCOUNT,
            FASTACCOUNT, ACCOUNTBIND,OTHER, LEGALPERSON } = BUSITYPE;
        if (targetId) param.targetId = targetId
        if (mobile) param.mobile = mobile
        if (verifyType && verifyType > 0) param.verifyType = verifyType
        let res = null;
        switch (verifyType) {
          // 登录业务
          case LOGINBUSI:
            res = await ApiMethods.AccountLoginController.aliCaptchaSend(param)
            break;
          // 业务
          case REGISTERBUSI:
          case FORGETBUSI:
          case AUTHBUSI:
          case ADDSBUSI:
          case AuthSendVerifiy:
          case OTHER:
            res = await ApiMethods.AccountLoginController.aliCaptchaSendCode(param)
            break;
          case SIGNBUSI:
            res = await ApiMethods.AccountLoginController.captchaSendCode({ ...param, ...parameters })
            break;
          case RETRIEVEACCOUNT:
            res = await ApiMethods.AnonyController.aliCaptchaSendIdenSms(param)
            break;
          case FASTACCOUNT:
            const SAPI = this.stateless ? ApiMethods.stateless.enterpriseAliCaptchaSendIdenSms : ApiMethods.IdenAuthController.enterpriseAliCaptchaSendIdenSms;
            res = await SAPI({ ...param, ...parameters })
            break;
          case LEGALPERSON:
            param.ts = this.$route.query.ts;
            param.uid = this.$route.query.uid;
            param.sign = this.$route.query.sign;
            param.multiSignatoryKey = this.$route.query.multiSignatoryKey;
            res = await ApiMethods.stateless.sendAuthByfaceSms(param)
            break;
          case ACCOUNTBIND:
            res = await ApiMethods.AccountLoginController.sendIdenSms(param)
            const codeType = ['10303', '10402', '2',].includes(res.code) && !res.success
            this.$message.error(res.description || '手机或者邮箱错误')
            if (codeType) resolve({
              captchaResult: true, // 验证码验证是否通过，boolean类型，必选
              bizResult: false, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
            })
            break;
          default:
            res = await ApiMethods.AccountLoginController.aliCaptcha(param)
            break;
        }
        // 2.构造标准返回参数
        if (!res.success) {
          switch (res.code) {
            case '10807':
            case '10802':
              // 套餐不足
              this.$message.error(res.description)
              resolve({ captchaResult: true, bizResult: false, })
              break;
            case '10505':
              // 业务类型错误
              this.$message.error(res.description)
              resolve({ captchaResult: true, bizResult: false, })
              break;
            case '10101':
              // 验证成功但重复发起
              this.$message.success(res.description)
              resolve({ captchaResult: true, bizResult: true, })
              break;
            default:
              resolve({ captchaResult: false })
          }
          return
        }
        if (res.success && res.code == '0' && !res.data) resolve({
          captchaResult: true, // 验证码验证是否通过，boolean类型，必选
          bizResult: true, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
        })
        if (res.success && res.code == '0' && res.data) {
          const {
            /** 验证码校验结果 */
            captchaVerifyResult,
            /** 短信发送结果 */
            sendVerifyCodeResult,
            /** 短信发送详情 */
            sendVerifyCodeInfo,
            /**短信发送失败信息 */
            sendVerifyCodeMsg,
            /** 短信发送失败错误码 */
            sendVerifyCodeResultCode
          } = res.data
          // if(captchaVerifyResult && sendVerifyCodeResult) {
          //   this.$message.success('短信发送成功')
          // }
          if (!!captchaVerifyResult) {
            this.$message.success('验证通过')
          }
          if (sendVerifyCodeInfo && sendVerifyCodeInfo.num) this.$message.error(sendVerifyCodeMsg)
          if (captchaVerifyResult && !sendVerifyCodeResult) this.$message.error(sendVerifyCodeMsg || '发送失败')
          resolve({
            captchaResult: captchaVerifyResult, // 验证码验证是否通过，boolean类型，必选
            bizResult: Boolean(sendVerifyCodeResult), // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
          });
        }
      })
    },
    // 验证通过后调用 (人话：原来该干嘛干嘛)
    onBizResultCallback (bizResult) {
      if (this.handCallback && bizResult) this.handCallback()
    },
    /** 初始化挂载 */
    init () {
      this.captchaButton = document.getElementById('captcha-button');
      window.initAliyunCaptcha({
        SceneId: '10lq13vq', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: 'lvkajq', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
        getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 360,
          height: 40,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      });
    },
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.$nextTick(() => { this.init() })
  },

  getInstance (instance) {
    this.captcha = instance;
  },
  beforeDestroy () {
    this.captchaButton = null;
    // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
    let mask = document.getElementById('aliyunCaptcha-mask'), popup = document.getElementById('aliyunCaptcha-window-popup')
    if (mask) mask.remove()
    if (popup) popup.remove()
  }
}
</script>
<style lang='less' scoped>
// @import url(); 引入公共css类
</style>



// WEBPACK FOOTER //
// components/send-auth-validcode/aliCaptchaNew.vue